import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { About } from '../components/landing/About';
import { ProjectDeck } from '../components/landing/ProjectDeck/ProjectDeck';
import { NarraCaseStudy } from '../components/landing/NarraCaseStudy';
import { Testimonial } from '../components/landing/Testimonial';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full overflow-x-hidden" style={{
    background: 'var(--bg)',
    color: 'var(--fg)'
  }} data-id="element-268" data-mp="2b2drnpwrtwsq">
      <Navbar data-id="element-269" data-mp="2kxffmifb8stq" />
      <Hero data-id="element-270" data-mp="2ky8fr0jrkk2w" />
      <About data-id="element-271" data-mp="2kwnszx3oy5fl" />
      <ProjectDeck data-id="element-272" data-mp="2fzno3pikv8q2" />
      <NarraCaseStudy data-id="element-273" data-mp="2fz45s7p0mibi" />
      <Testimonial data-id="element-274" data-mp="2g0p13zj5m5af" />
      <Footer data-id="element-275" data-mp="2g06y8k1zkstj" />
    </div>;
}